import React from 'react';

import Paper from '@material-ui/core/Paper';

import { useStyles } from './Themable.hoc';

import ProductsGridPane from './components/ProductsGridPane';
import ProductsPane from './components/ProductsPane';

import { useIsProductsPaneVisible } from './state/index.hooks';

const Products = () => {
    const classes = useStyles();

    const isPaneVisible = useIsProductsPaneVisible();

    const gridPaneClass = isPaneVisible
        ? classes.visibleGridPane
        : classes.hiddenGridPane;

    return (
        <div className={classes.pageWrapper}>
            <div className={gridPaneClass}>
                <ProductsGridPane />
            </div>

            {isPaneVisible && (
                <Paper className={classes.paneWrapper}>
                    <ProductsPane />
                </Paper>
            )}
        </div>
    );
};

export default Products;
